import { defineSlotRecipe } from '@chakra-ui/react';
import { popoverAnatomy } from '@chakra-ui/react/anatomy';
// Deep-merges over Chakra's default popover recipe: the shadow goes (house rule,
// no shadows) and a hairline border sets the panel apart instead, as the menu
// recipe does. The arrow tip already draws 1px borders, which now meet this one.
export const popoverRecipe = defineSlotRecipe({
    className: 'chakra-popover',
    slots: popoverAnatomy.keys(),
    base: {
        content: {
            boxShadow: 'none',
            borderWidth: '1px',
            borderColor: 'border',
        },
    },
});
